import {
  FAQ_LIST_QUESTION_ATTEMPT,
  FAQ_LIST_QUESTION_SUCCESS,
  FAQ_LIST_QUESTION_FAILED,
  ////////////////////////
  FAQ_MORELIST_QUESTION_SUCCESS,
  FAQ_MORELIST_QUESTION_ATTEMPT,
  ////////////////////////
  LOGOUT

} from "../types/faqQuestionTypes";

const INITIAL_STATE = {
  loading: false,
  loaded: false,
  list: [],
  error: "",

  ///////////

  page_size: 0,
  page_count: 0,
  loadingMore: false,

};

function faqQuestion(state = INITIAL_STATE, action) {
  switch (action.type) {
    case FAQ_LIST_QUESTION_ATTEMPT:
      return {
        ...state,
        loading: true,
      };

    case FAQ_LIST_QUESTION_SUCCESS:
      return {
        ...state,
        loading: false,
        loaded: true,
        list: action.data.list,
        page_size: action.data.size,
        page_count: action.data.size,
        error: ""
      };

    case FAQ_LIST_QUESTION_FAILED:
      return {
        ...state,
        loading: false,
        loaded: false,
        error: action.error,
        list: []
      };
    //////////////////////////////////
    case FAQ_MORELIST_QUESTION_ATTEMPT:
      return {
        ...state,
        loadingMore: true,
      };

    case FAQ_MORELIST_QUESTION_SUCCESS:
      return {
        ...state,
        loadingMore: false,
        list: state.list.concat(action.data.list),
        page_size: action.data.size,
        page_count: state.page_count + action.data.size,
        error: ""
      };


    case LOGOUT:
      return INITIAL_STATE;

    default:
      return state;
  }
}
export default faqQuestion;
